import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ro from './locales/ro/translation.json';

// ==============================|| I18N + GESTIONARE TEXTE ||============================== //
// Textele pornesc pe valorile locale (translation.json); după autentificare,
// TranslationsProvider aplică peste ele bundle-ul din BE (api/translations/bundle) —
// BE e sursa de adevăr, iar editările din „Gestionare texte" ajung tot acolo (PUT).

// Aplică o valoare pe o cheie punctată (common.save) în arborele de traduceri.
function applyOverride(
	target: Record<string, unknown>,
	dottedKey: string,
	value: string
): void {
	const parts = dottedKey.split('.');
	let node = target;
	for (let i = 0; i < parts.length - 1; i += 1) {
		const part = parts[i];
		if (!node[part] || typeof node[part] !== 'object') return; // cheie necunoscută — ignorăm
		node = node[part] as Record<string, unknown>;
	}
	const leaf = parts[parts.length - 1];
	if (typeof node[leaf] === 'string') node[leaf] = value;
}

// Gardă HMR: modulul are side-effect (init); la re-execuția prin Vite HMR un al doilea
// init() pe instanța vie poate lăsa store-ul de resurse gol (chei afișate literal).
if (!i18n.isInitialized) {
	i18n.use(initReactI18next).init({
		resources: {
			ro: { translation: ro as Record<string, unknown> }
		},
		lng: 'ro',
		fallbackLng: 'ro',
		interpolation: {
			escapeValue: false
		}
	});
}

// Aplică override-uri de text venite din BE (GET api/translations/bundle, via
// TranslationsProvider) PESTE resursele curente (default local + override-uri
// localStorage). Doar cheile CUNOSCUTE se suprascriu (applyOverride ignoră restul), iar
// `mobile.*` rămâne pentru aplicația mobilă. Fără override-uri (eroare / bundle gol)
// NU se schimbă nimic → rămân textele locale web (fallback).
export function applyRemoteTextOverrides(overrides: Record<string, string>): void {
	if (!overrides || typeof overrides !== 'object') return;
	const entries = Object.entries(overrides).filter(
		([key, value]) => typeof value === 'string' && !key.startsWith('mobile.')
	);
	if (entries.length === 0) return;

	const current = (i18n.getResourceBundle('ro', 'translation') ?? ro) as Record<
		string,
		unknown
	>;
	const merged = JSON.parse(JSON.stringify(current)) as Record<string, unknown>;
	entries.forEach(([key, value]) => applyOverride(merged, key, value));

	i18n.addResourceBundle('ro', 'translation', merged, true, true);
	// react-i18next re-randează pe `languageChanged` (bind implicit); addResourceBundle nu
	// emite singur un eveniment ascultat, deci îl declanșăm manual.
	i18n.emit('languageChanged', i18n.language);
}

export default i18n;
